import { Component, computed, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LabelViewerComponent } from '../label-viewer/label-viewer.component';
import { MinimapIconComponent } from '../icons/minimap-icon/minimap-icon.component';
import { HighlightBeamIconComponent } from '../icons/highlight-beam-icon/highlight-beam-icon.component';
import { TooltipWrapperComponent } from '../tooltip-wrapper/tooltip-wrapper.component';
import { CosmeticOptions, Displayable } from '../../models/filter-models';
import { DisplayType } from "../../models/enums";
import { Rarity } from "../../models/enums";
import { StylePickerDialogComponent } from './style-picker-dialog/style-picker-dialog.component';
import { CosmeticsGeneratorService } from '../../services/cosmetics-generator.service';
import { SettingsService } from '../../services/settings.service';
import { labelPreviewBgImageStyle } from '../label-preview-backgrounds';

@Component({
  selector: 'app-style-picker',
  imports: [MinimapIconComponent, HighlightBeamIconComponent, TooltipWrapperComponent, LabelViewerComponent, StylePickerDialogComponent],
  templateUrl: './style-picker.component.html',
  styleUrls: ['../rule-preview/label-preview-shared.scss', './style-picker.component.scss']
})
export class StylePickerComponent implements OnInit, OnChanges {
  private readonly settings = inject(SettingsService);

  labelBackgroundImage = computed(() => labelPreviewBgImageStyle(this.settings.labelPreviewBg()));

  @Input({ required: true }) displayable!: Displayable;

  @Input() disabled: boolean = false;
  @Input() exampleName?: string;
  @Input() defaultVisible: boolean = false;
  @Input() defaultHidden: boolean = false;
  @Input() forceHidden: boolean = false;

  @Input() rarity?: Rarity;
  @Input() isCurrency?: boolean;
  @Input() isWaystone?: boolean;
  @Input() isPoe1Gem?: boolean;
  @Input() isQuestItem?: boolean;
  @Input() title?: string;
  @Input() sockets?: string;
  @Input() influence?: string;
  @Input() fractured?: boolean;
  @Input() veiled?: boolean;

  @Input() allowDisactivate = true;
  @Input() allowHide = true;
  @Input() right = true;

  @Output() styleUpdated = new EventEmitter<void>();

  DisplayType = DisplayType;

  dialogOpen = false;

  cosmeticOptions: CosmeticOptions = new CosmeticOptions();
  hidden = false;

  constructor(private cosmeticsGeneratorService: CosmeticsGeneratorService) {}

  ngOnInit(): void {
    this.setCosmeticOptionsFromDisplayOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['displayable']) {
      this.setCosmeticOptionsFromDisplayOptions();
    }
  }

  setCosmeticOptionsFromDisplayOptions() {
    const result = this.cosmeticsGeneratorService.getCosmeticOptionsFromDisplayOptions(this.displayable.displayOptions, this.exampleName, this.title);
    Object.assign(this.cosmeticOptions, result.cosmeticOptions);
    this.hidden = result.hidden;
  }

  openStylePickerDialog() {
    if (!this.disabled) {
      this.dialogOpen = true;
    }
  }

  closeStylePickerDialog() {
    this.dialogOpen = false;
  }
}
